import { User } from '@/models/user.model'

import $ from 'jquery'

export default {

  data () {
    return {
      user: new User(),
      pad: [],
      errorMessage: '',
      version: require('../../../package.json').version
    }
  },

  created () {
    this.generatePad()
  },

  mounted () {
    $('#modalLogin').on('hidden.bs.modal', () => {
      this.user = new User()
    })
  },

  methods: {
    async login () {
      this.errorMessage = ''
      if (this.user.login === '' || this.user.password === '') {
        this.errorMessage = 'Au moins une des données saisies est erronée, incomplète ou manquante. Attention, composer plusieurs fois de suite une donnée erronée entraînera le blocage de votre accès au site. En cas de blocage, cliquez sur code oublié ou identifiant oublié.'
      } else {
        this.user.login = this.user.login.trim()
        this.$store.dispatch('user/login', this.user).then(
          response => {
            if (this.$store.state.user.user.loggedWithOtp) {
              this.user.login = this.$store.state.user.user.login
              this.$router.push({ name: 'changePassword', params: { 'userToUpdate': this.user, 'userExpired': false } })
              $('#modalLogin').modal('hide')
            } else if (this.$store.state.user.user.expiredAccount) {
              this.user.login = this.$store.state.user.user.login
              this.$router.push({ name: 'changePassword', params: { 'userToUpdate': this.user, 'userExpired': true } })
              $('#modalLogin').modal('hide')
            } else {
              this.$router.push({ name: response.firstPageUrl })
              $('#modalLogin').modal('hide')
            }
          },
          error => {
            if (error && error.response) {
              if (error.response.data === 'USER_ACCOUNT_LOCKED_BY_ADMINISTRATOR') {
                this.errorMessage = 'Votre compte est bloqué. Veuillez contacter votre administrateur pour le débloquer.'
              } else if (error.response.data === 'USER_RESET_PASSWORD_ONGOING') {
                this.errorMessage = 'Votre demande de récupération de mot de passe est en cours de traitement. Un courrier avec un code d\'accès à personnaliser sera envoyé à votre adresse sous 5 jours.'
              } else {
                this.errorMessage = 'Au moins une des données saisies est erronée, incomplète ou manquante. Attention, composer plusieurs fois de suite une donnée erronée entraînera le blocage de votre accès au site. En cas de blocage, cliquez sur code oublié ou identifiant oublié.'
              }
            }
            this.user.password = ''
          }
        )
      }
    },

    generatePad () {
      var numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]

      for (var i = 0; i < 10; i++) {
        let lengthBase = numbers.length - 1
        if (lengthBase > 0) {
          let catchedNumber = Math.floor(Math.random() * (lengthBase - 0 + 1))
          this.pad.push(numbers[catchedNumber])
          numbers.splice(catchedNumber, 1)
        } else {
          this.pad.push(numbers[0])
        }
      }
    },

    inputPassword (e) {
      if (this.user.password.length < 8) {
        this.user.password = this.user.password + e.toString()
      }
    },

    trimPassword () {
      this.user.password = this.user.password.slice(0, -1)
    }
  }
}
